import React, { useEffect, useState } from "react";
import {
  getSingleSurvey,
  updateStatus,
  addFormContent,
  updateFormContent,
  getFormContent,
  surveyResultPreview,
  sharePreviewLink,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import TextArea from "../../atoms/Textarea";
import DynamicCheckbox from "../../molecules/DynamicCheckbox";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../atoms/Input";
import removeImg from "../../../imgs/remove.png";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import WoodenLiftPageDownload from "./ClientSide/download";
import PrintComponent from "../PrintComponent";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";
import LoadingModal from "../../molecules/LoadingModal";
import moment from "moment";
import MySignatureCanvas from "../../molecules/signature_canvas";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import InventoryIcon from "@mui/icons-material/Inventory";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import PrintIcon from "@mui/icons-material/Print";

const WoodenLiftPage = () => {
  const [dataRows, setDataRows] = useState([
    {
      no: 1,
      liftVan: "120 KG",
      weight: "120 KG",
      man_date: "12-09-2023",
    },
  ]);
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    dataRows: [
      {
        noOfWoodenLift: "",
        liftVanBoxSizes: "",
        tareWt: "",
        data: "",
      },
    ],
    customerName: "",
    customerEmail: "",
    fileRef: "",
    correctSize: true,
    plyWood: false,
    woodBars: false,
    partsWellTogether: false,
    holesCrakes: false,
    holesFilledWithSilicon: false,
    cratesWaterproof: true,
    cratesRoof: true,
    clearlyMentioned: true,
    tiedUpCrates: false,
    tareWeightNoted: true,
    carpenterRemarks: "",
    managerRemarks: "",
    managerWarehouseSign: "",
    carpenterSign: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleAddNewDataRows = () => {
    let fC = { ...formContent };
    const values = [...formContent?.dataRows];

    values.push({
      noOfWoodenLift: "",
      liftVanBoxSizes: "",
      tareWt: "",
      data: "",
    });
    fC.dataRows = values;

    setFormContent(fC);
  };

  const handleRemoveDataRows = (ind) => {
    let fC = { ...formContent };
    const values = [...formContent?.dataRows];
    values.splice(ind, 1);
    fC.dataRows = values;
    setFormContent(fC);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.customerName = `${response?.data?.data?.surveyDetail?.name}`;
        values.customerEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.fileRef = `${response?.data?.data?.surveyDetail?.id}`;

        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.customerName = `${response?.data?.data?.name}`;
          values.customerEmail = `${response?.data?.data?.email}`;
          values.fileRef = `${response?.data?.data?.id}`;

          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage(
          "Wooden Lift Van Quality Check Report has been added successfully!"
        );
        setOpenSnackbar(true);
        navigate(-1);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          "Wooden Lift Van Quality Check Report has been updated successfully!"
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  useEffect(() => {
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  const [isShare, setIsShare] = useState(false);

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "wooden-lift-van-quality-check-report-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Wooden Lift Van Quality Check Report has been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const printAction = () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("print-component");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;
      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        const footerHeight =
          printElement.getElementsByTagName("tfoot")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight);
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };

  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();
    if (whichSign == "manager") setUploadText1("Uploading...");
    if (whichSign == "carpenter") setUploadText2("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };
        let dlt = [...mediaKeysToRemove];
        if (whichSign == "manager") {
          if (formContent.managerWarehouseSign?.trim()?.length != 0)
            dlt.push(formContent.managerWarehouseSign);
          values.managerWarehouseSign = res?.data?.data?.key;
        }
        if (whichSign == "carpenter") {
          if (formContent.carpenterSign?.trim()?.length != 0)
            dlt.push(formContent.carpenterSign);
          values.carpenterSign = res?.data?.data?.key;
        }
        setFormContent(values);

        setMediaKeysToRemove(dlt);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            sendEditRequestToAdmin();
          }}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="outlined"
          onClick={() => {
            setIsShare(true);
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            border: "1px solid var(--glass-border)",
            color: "var(--text-main)",
            '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
          }}
        >
          Share
        </Button>
      )}

      {isEdit && flg == "2" && (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
           sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (flg == "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 32px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }
            var tempTitle = document.title;
            document.title = `Wooden Lift Van Quality Check Report-${
              formContent?.customerName
            }-${moment(new Date()).format("DD.MM.YYYY")}`;

            window.print();
            document.title = tempTitle;
          }}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--text-main)",
             boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
             '&:hover': { backgroundColor: '#000' }
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout
        title="Wooden Lift Van Quality Check Report"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <SectionHeader title="General Information" icon={<PersonIcon />} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>

          {/* customer detail*/}
          <div className={`${isEdit ? "p-3 px-0 rounded mb-5" : ""}`}>
            <div className="contact-detail d-flex mt-2 row">
              {/* left col */}
              <div className={`left-col col-12 col-md-6 text-start`}>
                <Typography variant="body1" gutterBottom>
                  <ContactDetailField
                    label="Customer Name"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"120px"}
                    value={formContent?.customerName}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.customerName = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />
                  <ContactDetailField
                    label="File Ref"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"120px"}
                    value={formContent?.fileRef}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.fileRef = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />
                </Typography>
              </div>
            </div>
          </div>
          {/* /customer detail */}
          </PremiumCard>

          <SectionHeader title="Wooden Lift Van Details" icon={<InventoryIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>

          <div className="overflow-x-auto mb-5 Weight-Ticket-Table mt-5">
            <Table
              responsive
              // striped
              // bordered
              // hover
              style={{ overflowX: "auto" }}
            >
              {/* Table Header */}
              <thead
                className="bg-white"
                // className="bg-body-tertiary"
              >
                <tr>
                  <th className="border p-3 text-start min-w-150">
                    {" "}
                    No. of Wooden lift vans
                  </th>
                  <th className="border p-3 text-start min-w-400">
                    Lift van or Box Sizes IN/OUT
                  </th>
                  <th className="border p-3 text-start">Tare weight</th>
                  <th className="border p-3 text-start min-w-100">
                    Manufacturer Date
                  </th>

                  {isEdit && <th className="border p-3"></th>}
                </tr>
              </thead>
              <tbody className="bg-white">
                {formContent?.dataRows?.length > 0 ? (
                  <>
                    {formContent?.dataRows?.map((row, index) => {
                      return (
                        <tr>
                          <td className="border p-3 text-start">{index + 1}</td>
                          <td className="border p-3 text-start">
                            {isEdit ? (
                              <Input
                                id="condition"
                                label="Lift van or Box Sizes.."
                                type="text"
                                style="full-border-field"
                                value={row?.liftVanBoxSizes}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  const valuesRows = [...formContent?.dataRows];
                                  valuesRows[index].liftVanBoxSizes =
                                    e.target.value;
                                  values.dataRows = valuesRows;
                                  setFormContent(values);
                                }}
                                inline={{ width: "-webkit-fill-available" }}
                              />
                            ) : row.liftVanBoxSizes ? (
                              row.liftVanBoxSizes
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="border p-3 text-start min-w-100">
                            {isEdit ? (
                              <>
                                <Input
                                  id="condition"
                                  label="Tare weight..."
                                  type="text"
                                  style="full-border-field"
                                  value={row?.tareWt}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].tareWt = e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: "-webkit-fill-available" }}
                                />
                              </>
                            ) : row.tareWt ? (
                              `${row.tareWt}`
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="border p-3 text-start min-w-100">
                            {isEdit ? (
                              <>
                                <Input
                                  id="condition"
                                  label="Date..."
                                  type="date"
                                  style="full-border-field"
                                  value={row?.date}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].date = e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: "-webkit-fill-available" }}
                                />
                              </>
                            ) : row.date ? (
                              formatDate(row.date)
                            ) : (
                              "-"
                            )}
                          </td>

                          {isEdit && (
                            <td className="border p-3 text-start">
                              <img
                                src={removeImg}
                                height={18}
                                width={18}
                                className="cursor-pointer"
                                onClick={() => handleRemoveDataRows(index)}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td className="text-center" colSpan={isEdit ? 5 : 4}>
                      {isLoading ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "10px 0px",
                          }}
                        >
                          <CircularProgress
                            style={{
                              color: "#00aff0",
                              height: "25px",
                              width: "25px",
                            }}
                          />
                        </Box>
                      ) : (
                        <div className="d-flex justify-content-center">
                          <p className="my-3">No Records to Show</p>
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <Row>
            <Col className="col-12 text-end">
              {isEdit && (
                <Button
                  className="add-new-btn ms-auto"
                  onClick={() => {
                    handleAddNewDataRows();
                  }}
                >
                  Add New
                </Button>
              )}
            </Col>
          </Row>
          </PremiumCard>

          <SectionHeader title="Quality Check" icon={<CheckCircleIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Row>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="1. The correct size of lift van was measured."
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.correctSize}
                  value2={formContent?.correctSize}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.correctSize = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.correctSize = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
            <Col sm={12} md={4} className="mb-4">
              <div className="">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="2. The crates build with new ply wood sheets."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.plyWood}
                    value2={formContent?.plyWood}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.plyWood = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.plyWood = false;
                      setFormContent(values);
                    }}
                    disabled={!isEdit ? true : false}
                  />
                </Typography>
              </div>
            </Col>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="3. The crates build with new wood bars."
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.woodBars}
                  value2={formContent?.woodBars}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.woodBars = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.woodBars = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
            <Col sm={12} md={4} className="mb-4">
              <div className="">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="4. All the parts and joints are well together."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.partsWellTogether}
                    value2={formContent?.partsWellTogether}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.partsWellTogether = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.partsWellTogether = false;
                      setFormContent(values);
                    }}
                    disabled={!isEdit ? true : false}
                  />
                </Typography>
              </div>
            </Col>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="5. Is there any holes/cracks found in the crate?"
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.holesCrakes}
                  value2={formContent?.holesCrakes}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.holesCrakes = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.holesCrakes = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
            <Col sm={12} md={4} className="mb-4">
              <div className="">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="6. If yes, has the holes/cracks filled up with silicon?"
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.holesFilledWithSilicon}
                    value2={formContent?.holesFilledWithSilicon}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.holesFilledWithSilicon = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.holesFilledWithSilicon = false;
                      setFormContent(values);
                    }}
                    disabled={!isEdit ? true : false}
                  />
                </Typography>
              </div>
            </Col>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="7. The crates fully waterproofed from inside with plastic sheets."
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.cratesWaterproof}
                  value2={formContent?.cratesWaterproof}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.cratesWaterproof = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.cratesWaterproof = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
            <Col sm={12} md={4} className="mb-4">
              <div className="">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="8. The crates roof top has intact with tin sheet."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.cratesRoof}
                    value2={formContent?.cratesRoof}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.cratesRoof = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.cratesRoof = false;
                      setFormContent(values);
                    }}
                    disabled={!isEdit ? true : false}
                  />
                </Typography>
              </div>
            </Col>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="9 .The signs and shipper details are clearly mentioned on crates"
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.clearlyMentioned}
                  value2={formContent?.clearlyMentioned}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.clearlyMentioned = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.clearlyMentioned = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
            <Col sm={12} md={4} className="mb-4">
              <div className="">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="10. The crates tie-up with steel bindings all around."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.tiedUpCrates}
                    value2={formContent?.tiedUpCrates}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.tiedUpCrates = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.tiedUpCrates = false;
                      setFormContent(values);
                    }}
                    disabled={!isEdit ? true : false}
                  />
                </Typography>
              </div>
            </Col>
            <Col sm={12} md={8} className="mb-4">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicCheckbox
                  label="11. The tare weight of the lift van noted."
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.tareWeightNoted}
                  value2={formContent?.tareWeightNoted}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.tareWeightNoted = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.tareWeightNoted = false;
                    setFormContent(values);
                  }}
                  disabled={!isEdit ? true : false}
                />
              </Typography>
            </Col>
          </Row>

          {/* <div className="contact-detail d-flex mt-5 row"> */}
          {/* left col */}
          {/* <div className={`left-col text-start pe-5 col-12 col-lg-8`}>
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicCheckbox
                label="9 .The signs and shipper details are clearly mentioned on crates"
                checkId1="check1"
                checkLabel1="Yes"
                checkId2="check2"
                checkLabel2="No"
                value1={formContent?.clearlyMentioned}
                value2={formContent?.clearlyMentioned}
                onChange1={(e) => {
                  let values = { ...formContent };
                  values.clearlyMentioned = true;
                  setFormContent(values);
                }}
                onChange2={(e) => {
                  let values = { ...formContent };
                  values.clearlyMentioned = false;
                  setFormContent(values);
                }}
                disabled={!isEdit ? true : false}
              />
            </Typography>
          </div> */}
          {/* right col */}
          {/* <div className={`right-col ps-5 pe-2 col-12 col-lg-4`}>
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicCheckbox
                label="10. The crates tie-up with steel bindings all around."
                checkId1="check1"
                checkLabel1="Yes"
                checkId2="check2"
                checkLabel2="No"
                value1={formContent?.tiedUpCrates}
                value2={formContent?.tiedUpCrates}
                onChange1={(e) => {
                  let values = { ...formContent };
                  values.tiedUpCrates = true;
                  setFormContent(values);
                }}
                onChange2={(e) => {
                  let values = { ...formContent };
                  values.tiedUpCrates = false;
                  setFormContent(values);
                }}
                disabled={!isEdit ? true : false}
              />
            </Typography>
          </div> */}
          {/* </div> */}
           </PremiumCard>

           <SectionHeader title="Remarks" icon={<CommentIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>

          {/*  Carpenter Remarks*/}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="mb-2">
                <label
                  htmlFor="carpenterRemarks"
                  className={`fw-bold ${isEdit ? "mb-3" : "mb-1"}`}
                >
                  Carpenter Remarks:
                </label>
                {!isEdit ? (
                  <p>
                    {formContent?.carpenterRemarks
                      ? formContent?.carpenterRemarks
                      : "-"}
                  </p>
                ) : (
                  <TextArea
                    rows="3"
                    label="Carpenter remarks..."
                    id="carpenterRemarks"
                    value={formContent?.carpenterRemarks}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.carpenterRemarks = e.target.value;
                      setFormContent(values);
                    }}
                  />
                )}
              </div>
            </Typography>
          </div>
          {/* / Carpenter Remarks */}

          {/*  Manager Warehouse remarks:*/}
          <div className="my-5 pe-1 ">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="mb-2">
                <label
                  htmlFor="managerWarehouse"
                  className={`fw-bold ${isEdit ? "mb-3" : "mb-1"}`}
                >
                  Manager Warehouse Remarks:
                </label>
                {!isEdit ? (
                  <p>
                    {formContent?.managerRemarks
                      ? formContent?.managerRemarks
                      : "-"}
                  </p>
                ) : (
                  <TextArea
                    rows="3"
                    label="Manager warehouse remarks:..."
                    id="managerWarehouse"
                    value={formContent?.managerRemarks}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.managerRemarks = e.target.value;
                      setFormContent(values);
                    }}
                  />
                )}
              </div>
            </Typography>
          </div>
          {/* / Manager Warehouse remarks */}
           </PremiumCard>

           <SectionHeader title="Approvals" icon={<GavelIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>

          {/* Signatures */}
          <Row className="mt-5 pt-5 no-print">
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.managerWarehouseSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText1}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("manager");
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent?.managerWarehouseSign}`}
                      height={80}
                      width={200}
                    />
                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign1"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign1"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("manager");
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent.managerWarehouseSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.managerWarehouseSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>

              <p className="mb-0">{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Manager Warehouse"}</b>
              </p>

              {""}
            </Col>
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.carpenterSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign2"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText2}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign2"
                          name="uploadSign2"
                          onClick={() => {
                            setWhichSign("carpenter");
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent.carpenterSign}`}
                      height={80}
                      width={200}
                    />
                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("carpenter");
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent.carpenterSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.carpenterSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
              <p className="mb-0">{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Carpenter"}</b>
              </p>

              {""}
            </Col>
          </Row>
          </PremiumCard>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000} // Adjust the duration as needed
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={
              snackbarMessage?.includes("successful") ? "success" : "error"
            }
            onClose={handleCloseSnackbar}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

        {/* share with client */}
        {isShare && (
          <ShareWithClientsModal
            open={isShare}
            onClose={() => {
              setIsShare(false);
            }}
            onSuccess={(emails) => {
              shareWithClient(emails);
            }}
          />
        )}

        <LoadingModal open={open} handleClose={handleClose} />

        {/* Add signature Modal */}
        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}

        {isVerified && (
          <SuperAdminVerifationModal
            open={isVerified}
            onClose={() => {
              setIsVerified(false);
            }}
            onSuccess={() => {
              setIsEdit(true);
              setIsVerified(false);
            }}
            onError={() => {
              // shareWithClient(emails);
              setSnackbarMessage("Invalid Confirm Pin");
              setOpenSnackbar(true);
            }}
          />
        )}
      </PremiumPageLayout>

      <PrintComponent>
        <WoodenLiftPageDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>
    </>
  );
};
export default WoodenLiftPage;
